// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-cTV","label":"styles_label__I2BE9"};